
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useState } from "react";
import { BlogPostsList } from "@/components/blog/BlogPostsList";

export default function Blog() {
  const [expandedPosts, setExpandedPosts] = useState<{[key: string]: boolean}>({
    post1: false,
    post2: false,
    post3: false,
    post4: false,
    post5: false,
    post6: false,
    post7: false,
    post8: false
  });

  const togglePost = (postId: string) => {
    setExpandedPosts(prev => {
      // Create a new object with all posts collapsed
      const newState = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {} as {[key: string]: boolean});
      
      // Then toggle only the clicked post
      newState[postId] = !prev[postId];
      return newState;
    });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-24">
        <h1 className="text-xl text-gray-700 mb-6">Les posts</h1>
        <BlogPostsList expandedPosts={expandedPosts} togglePost={togglePost} />
      </main>
      <Footer />
    </div>
  );
}
